<template>
  <div>
    <h4>Negociación</h4>
    <p>Modifique los valores negociables que desee para poder enviar su propuesta.</p>

    <div class="negotiation-form">
      <div class="input-group format-type" v-if="offer.negotiableAttributes.price">
        <input placeholder="Precio"
               name="ng-price"
               data-test="input-priceNegotiation" 
               v-validate="'required|min_value:1|maxPrice'"
               ref='price'
               @keydown.188="replaceForDot"
               v-model="attributes.price"
               class="changed">
        <label data-test="labelPrecioNegotiation">Precio</label>
        <span class="text-validation">$/kg sin IVA</span>
        <div v-if="this.errors.has('ng-price')" class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
          <span> {{ this.errors.first('ng-price') }}</span>
        </div>
      </div>
      <div class="input-group" v-if="offer.negotiableAttributes.quantity">
        <input placeholder="Cantidad de animales" 
               name="ng-quantity"
               data-test="input-quantityAnimalsNegotiation" 
               ref='quantity'
               v-validate="{ required: true, numeric: true, min_value: 1, max:6, max_value: offer.quantityLeft }"
               v-model.number="attributes.quantity" 
               class="changed">
        <label data-test="labelQuantityNegotiation">Cantidad de animales</label>
        <div v-if="this.errors.has('ng-quantity')" class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
          <span> {{ this.errors.first('ng-quantity') }}</span>
        </div>
      </div>
      <div class="input-group format-type" v-if="offer.negotiableAttributes.slaughterWeight" >
        <input placeholder="Peso Faena" 
               name="ng-slaughterWeight"
               data-test="input-slaughterWeightNegotiation"
               ref="slaughterWeight"
               @keydown.188="replaceForDot"
               v-validate="'required|min_value:1|maxValue'"
               v-model="attributes.quality.slaughterWeight" 
               class="changed">
        <label data-test="labelSlaughterWeightNegotiation">Peso Faena</label>
        <span class="text-validation">(± 5) Kgs</span>
        <div v-if="this.errors.has('ng-slaughterWeight')" class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
          <span> {{ this.errors.first('ng-slaughterWeight') }}</span>
        </div>
      </div>
      <div class="input-group format-type" v-if="offer.negotiableAttributes.leanQuality" >
        <select name="ng-leanQuality"
                v-model="attributes.quality.leanQuality"
                ref="leanQuality"
                v-validate="'required'"
                class="changed"
                label-placeholder="Calidad magro">
          <option value="" disabled>Calidad Magro</option>
          <option :key="index"
                  :value="qualityOption"
                  :text="qualityOption"
                  v-for="(qualityOption,index) in leanQualityList">
          <!-- :selected="negotiation.id ? negotiation.quality.leanQuality === qualityOption : offer.quality.leanQuality === qualityOption">-->
            {{ qualityOption }}
          </option>
        </select>
        <label data-test="labelQualityLeanNegotiation" for="state">Calidad Magro</label>
        <div class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
          <span> {{ this.errors.first('ng-leanQuality') }}</span>
        </div>
      </div>
      <div class="input-group format-type" v-if="offer.negotiableAttributes.performance" >
        <input placeholder="Rendimiento" 
               name="ng-performance"
               ref="performance"
               @keydown.188="replaceForDot"
               v-validate="'required|decimal:2|min_value:1|max_value:100'"
               v-model="attributes.quality.performance" 
               class="changed">
        <label data-test="labelPerfomanceNegotiation">Rendimiento</label>
        <span class="text-validation">%</span>
        <div v-if="this.errors.has('ng-performance')" class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
          <span> {{ this.errors.first('ng-performance') }}</span>
        </div>
      </div>
      <div class="input-group format-type" v-if="offer.negotiableAttributes.dorsalFat" >
        <input placeholder="Grasa Dorsal" 
               name="ng-dorsalFat"
               ref="dorsalFat"
               @keydown.188="replaceForDot"
               v-model="attributes.quality.dorsalFat" 
               v-validate="'required|decimal:2|min_value:1|max_value:50'"
               class="changed">
        <label data-test="labelDorsalFatNegotiation">Grasa Dorsal</label>
        <span class="text-validation">mm</span>
        <div v-if="this.errors.has('ng-dorsalFat')" class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
          <span> {{ this.errors.first('ng-dorsalFat') }}</span>
        </div>
      </div>
      <div class="secure-payment">
        <div class="switch" v-if="offer.negotiableAttributes.securePayment.lock">
          <label for="">Pago seguro</label>
          <input class="we-toggle"
                ref="securePayment" 
                type="checkbox" 
                name="securePaymentLock" 
                v-model="securePaymentSwitch"/>
        </div>

        <div class="input-group format-type" v-if="offer.negotiableAttributes.securePayment.percentage">
          <input placeholder="Porcentaje de pago seguro" 
                name="ng-percentage"
                ref="percentage"
                @keydown.188="replaceForDot"
                v-model.number="attributes.securePayment.percentage" 
                v-validate="'required|decimal|min_value:1|max_value:99'"
                class="changed"
                :disabled="disabledSecurePaymentAttributes">
          <label>Porcentaje de pago seguro</label>
          <span class="text-validation">%</span>
          <div v-if="this.errors.has('ng-percentage')" class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
            <span> {{ this.errors.first('ng-percentage') }}</span>
          </div>
        </div>

        <div class="input-group format-type" v-if="offer.negotiableAttributes.securePayment.lapse">
          <select name="securePaymentDateSelector"
                  v-validate="'required'"
                  :danger="this.errors.has('securePaymentDateSelector')"
                  v-model.number="attributes.securePayment.lapse"
                  :class="{changed: !!(attributes.securePayment.lapse)}"
                  :disabled="disabledSecurePaymentAttributes">
            <option value="">Fecha de Transferencia de pago seguro</option>
            <option :key="index" :value="item" :text="item" v-for="(item,index) in securePaymentDateList">{{ item }} hs.</option>
          </select>
          <label for="securePaymentDateSelector">Fecha de Transferencia de pago seguro</label>
          <div class="con-text-validation span-text-validation-danger vs-input--text-validation-span">
            <span>{{ this.errors.first('securePaymentDateSelector') }}</span>
          </div>
        </div> 
      </div>
      
      <div class="switch" v-if="offer.negotiableAttributes.deliveryAtDestination">
        <label for="">Entrega en destino</label>
        <input class="we-toggle"
              data-test="select-deliveryAtDestinationNegotiation"
              ref="deliveryAtDestination" 
              type="checkbox" 
              name="deliveryAtDestination" 
              v-model="attributes.deliveryAtDestination"/>
      </div>
    </div>
    <div v-if="buttons" class="negotiation-actions">
      <button class="btn btn-secondary" @click="cleanNegotiation">Cancelar</button>
      <button data-test="button-sendReNegotiation" class="btn btn--inverted success" @click="sendAction()">Negociar</button>
    </div>
    
    <div v-if="this.negotiationMsg" class="o-alert o-alert--danger">
      {{ $t(`offer.negotiations.${negotiationMsg}`) }}
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import axios from 'axios'
import { print } from 'graphql'

const SelectableAttributes = gql`
  query retrieveSelectableAttributes($object: String!, $attribute: String!) {
    retrieveSelectableAttributes(object: $object, attribute: $attribute) {
      code
      selectableAttributes
      message
      success
    }
  }
`

export default {
  name: 'negotiation-row',
  props: {
    offer: {
      type: Object,
      required: true
    },
    negotiation: {
      type: Object,
      required: false,
      default: function () {
        return {}
      }
    },
    negotiationMsg: {
      type: String,
      required: false
    },
    buttons: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      attributes: {price: '', quantity: '', deliveryAtDestination: '', quality: {slaughterWeight: '', leanQuality: '', performance: '', dorsalFat: ''}, securePayment: {percentage: '', lapse: ''}},
      leanQualityList: [],
      securePaymentDateList: [],
      securePaymentSwitch: false
    }
  },
  beforeMount () {
    this.getLeanQualityList()
    this.getSecurePaymentLapseList()
    this.setInitialAttrs() 
    if (this.negotiation.id) {
      if (this.negotiation.securePayment && this.offer.negotiableAttributes.securePayment.lock) {this.securePaymentSwitch = true}
    } else {
      if (this.offer.securePayment && this.offer.negotiableAttributes.securePayment.lock) {this.securePaymentSwitch = true} 
    }
  },
  watch: {
    negotiation () {
      if (negotiation.id) {
        this.setInitialAttrs()
      }
    },
    offer () {
      this.attributes = {price: '', quantity: '', deliveryAtDestination: '', quality: {slaughterWeight: '', leanQuality: '', performance: '', dorsalFat: ''}, securePayment: {percentage: '', lapse: ''}}
      if (this.offer.id) {
        this.reloadInitialAttrs() 
      }
    }
  },
  computed: {
    disabledSecurePaymentAttributes () {
       if (this.offer.negotiableAttributes.securePayment.lock) {
        if (!this.securePaymentSwitch) {
          this.attributes.securePayment.percentage = "";
          this.attributes.securePayment.lapse = "";
          return true;
        }
      }
      return false;
    }
  },
  methods: {
    replaceForDot() {
      event.preventDefault()
      event.target.value = event.target.value + '.'
    },
    sendAction () {
      this.$validator.validate().then(res => {
        if (res) {
          if (this.negotiation.id) {
            this.takeActionOnNegotiation()
          } else {
            this.offerFirstOperation()
          }
        }
      })
    },
    attachFieldValidation (name) {
      console.log("attached")
      this.$validator.attach(name)
    },
    detachAllFieldValidation () {
      this.$validator.detach('ng-price')
      this.$validator.detach('ng-quantity')
      this.$validator.detach('ng-slaughterWeight')
      this.$validator.detach('ng-leanQuality')
      this.$validator.detach('ng-performance')
      this.$validator.detach('ng-dorsalFat')
      this.$validator.detach('ng-percentage')
      this.$validator.detach('ng-lapse')
      //this.$validator.detach('ng-securePayment')
    },
    async reloadInitialAttrs () {
      await this.setInitialAttrs()
    },
    setInitialAttrs () {
      this.detachAllFieldValidation()
      var obj = 'offer'
      if (this.negotiation.id) { obj = 'negotiation' }
      if (this.offer.negotiableAttributes.securePayment.percentage) {
        this.attributes.securePayment.percentage = this[obj].securePayment ? this[obj].securePayment.percentage : ''
      } else if (Object.values(this.offer.negotiableAttributes.securePayment).includes(true) && this.offer.securePayment) {
        this.attributes.securePayment.percentage = this.offer.securePayment.percentage
      }
      if (this.offer.negotiableAttributes.securePayment.lapse) {
        this.attributes.securePayment.lapse = this[obj].securePayment ? this[obj].securePayment.lapse : ''
      } else if (Object.values(this.offer.negotiableAttributes.securePayment).includes(true) && this.offer.securePayment) {
        this.attributes.securePayment.lapse = this.offer.securePayment.lapse
      }
      if (this.offer.negotiableAttributes.price) {
        this.attributes.price = String(this[obj].price)
      } else {
        delete this.attributes.price
      }
      if (this.offer.negotiableAttributes.quantity) {
        this.attributes.quantity = (obj === "offer") ? this.offer.quantityLeft : this.negotiation.quantity
      } else {
        delete this.attributes.quantity
      }
      if (this.offer.negotiableAttributes.slaughterWeight) {
        this.attributes.quality.slaughterWeight = this[obj].quality.slaughterWeight
      } else {
        delete this.attributes.slaughterWeight
      }
      if (this.offer.negotiableAttributes.leanQuality) {
        this.attributes.quality.leanQuality = this[obj].quality.leanQuality 
      } else {
        delete this.attributes.leanQuality
      }
      if (this.offer.negotiableAttributes.performance) {
        this.attributes.quality.performance = this[obj].quality.performance
      } else {
        delete this.attributes.performance
      }
      if (this.offer.negotiableAttributes.dorsalFat) {
        this.attributes.quality.dorsalFat = this[obj].quality.dorsalFat
      } else {
        delete this.attributes.dorsalFat
      }
      if (this.offer.negotiableAttributes.deliveryAtDestination) {
        this.attributes.deliveryAtDestination = this[obj].deliveryAtDestination 
      } else {
        delete this.attributes.deliveryAtDestination
      }
    },
    adjustAttributesBeforeEmit () {
      let attrs = {...this.attributes}
      if (this.disabledSecurePaymentAttributes) {
        attrs.securePayment = null
      }
      if (this.attributes.securePayment.percentage == '' && this.attributes.securePayment.lapse == '') {
        if (this.securePaymentSwitch) {
          attrs.securePayment = {percentage: this.offer.securePayment.percentage, lapse: this.offer.securePayment.lapse} 
        } else {
          attrs.securePayment = null
        }
      }
      return attrs
    },
    takeActionOnNegotiation () { 
      let filterAttributes = this.adjustAttributesBeforeEmit()
      this.$emit('take-action', this.negotiation, filterAttributes)
    },
    cleanNegotiation () {
      this.$emit('clean-actions')
    },
    offerFirstOperation () { 
      let filterAttributes = this.adjustAttributesBeforeEmit()
      this.$emit('create-negotiation', filterAttributes) 
    },
    getSecurePaymentLapseList () {
      axios.get(`${process.env.VUE_APP_GRAPH_PATH}`, { params: {
        query: print(SelectableAttributes),
        variables: {
          object: "marketplace/secure_payment",
          attribute: "lapse"
        }
      }}).then( res => { 
        if (!res.data.errors) {
          if (res.data.data.retrieveSelectableAttributes.success) {
            this.securePaymentDateList = res.data.data.retrieveSelectableAttributes.selectableAttributes
          }
        }
      })

    },
    getLeanQualityList () {
      axios.get(`${process.env.VUE_APP_GRAPH_PATH}`, { params: {
        query: print(SelectableAttributes),
        variables: {
          object: "marketplace/quality",
          attribute: "lean_quality"
        }
      }}).then( res => { 
        if (!res.data.errors) {
          if (res.data.data.retrieveSelectableAttributes.success) {
            this.leanQualityList = res.data.data.retrieveSelectableAttributes.selectableAttributes
          }
        }
      })
    },
  }
}
</script>
